import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { throwError } from 'rxjs';
import { NotificationService } from './notification.service';

declare let toastr: any;

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService {
  constructor(
    private router: Router,
    private readonly ngxLoader: NgxUiLoaderService,
    private notificationService: NotificationService,
  ) {}

  handleError({ error }: HttpErrorResponse, api = '') {
    if (!error) {
      this.ngxLoader.stop();

      return throwError('');
    }
    if (this.router.url.includes('/login') || this.router.url.includes('/signup') || this.router.url.includes('/password-reset')) {
      this.ngxLoader.stop();
      return throwError(error);
    }
    if (error.status === 401) {
      this.showError('Logged out, please log in again');
      localStorage.clear();
      this.router.navigate(['/login']);
      localStorage.setItem('returnUrl', this.router.url);
      this.ngxLoader.stop();
    } else if (error.status === 403) {
      const errorMessage = error.message || `Error ${error.status}`;
      this.showErrorReportProblem(errorMessage, api, error.status, error.timestamp);
      if (!this.router.url.includes('/ui-kit')) {
        this.router.navigateByUrl('/automap');
      }
      this.ngxLoader.stop();
    } else if (error.status >= 400 && error.status < 500) {
      const errorMessage = error.message || `Error ${error.status}`;
      this.showErrorReportProblem(errorMessage, api, error.status, error.timestamp);
      this.ngxLoader.stop();
    } else if (error.status >= 500 && error.status < 600) {
      const errorMessage = error.message || `Error ${error.status}`;
      this.showErrorReportProblem(errorMessage, api, error.status, error.timestamp);
      this.ngxLoader.stop();
    }
    this.ngxLoader.stop();

    return throwError(error);
  }

  showError(msg: string) {
    toastr.error(msg);
  }

  showWarning(msg: string) {
    toastr.warning(msg);
  }

  showErrorReportProblem(msg: string, api: string, status: string, timestamp: string) {
    if (!msg) {
      msg = 'Unexpected application error.';
    }
    toastr.error("<span id='reportProblemLink' style='color:#109cf1;font-size:13px;'>Report Problem</span>", msg, {
      closeButton: false,
      allowHtml: true,
      timeOut: 0,
      onShown: (toast) => {
        const link = document.querySelector('#reportProblemLink');
        link.addEventListener('click', () => {
          const description = 'Error: ' + msg + ' REST: ' + api + ' Status: ' + status + ' Date: ' + new Date(timestamp);
          this.notificationService.sendErrorFeedback(description).subscribe((data) => {
            this.notificationService.showSuccess('Feedback sent successfully.');
          });
        });
      },
    });
  }

  notFound(message: string, redirect = true): void {
    if (redirect) {
      this.showError(message);
      this.router.navigateByUrl('/automap');
    } else {
      localStorage.removeItem('access_token_automap');
      localStorage.removeItem('user_data_automap');
      localStorage.removeItem('refresh_token_automap');
      localStorage.clear();
      this.router.navigateByUrl('/login');
      window.location.reload();
    }
  }

  notAuthenticated(): void {
    localStorage.clear();
    this.router.navigate(['/login']);
    if (!this.router.url.includes('/login') && !this.router.url.includes('/signup') && !this.router.url.includes('/password-reset')) {
      localStorage.setItem('returnUrl', this.router.url);
    }
  }
}
